import * as ActionTypes from "../ActionTypes";

// --- Employee ECMS Adjustment Actions ---
export const GetEmployeeEcmsAdjustmentAction = (params) => {
  return {
    type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET,
    params,
  };
};

export const AddEmployeeEcmsAdjustmentAction = (params) => {
  return {
    type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD,
    params,
  };
};

export const UpdateEmployeeEcmsAdjustmentAction = (params) => {
  return {
    type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE,
    params,
  };
};

export const DeleteEmployeeEcmsAdjustmentAction = (params) => {
  return {
    type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE,
    params,
  };
};
